import { useAuth } from '../AuthContext';
import { Navigate, useLocation } from 'react-router-dom';

// `permitirGoleiro`: telas que o goleiro logado também usa (ex.: avaliação da pelada)
export function AuthMiddleware({ children, permitirGoleiro = false }) {
  const { isAuthenticated, userLogado } = useAuth();
  const location = useLocation();

  // Verifica se o usuário está autenticado
  if (!isAuthenticated) {
    // Se não estiver autenticado, redireciona para a página de login (e volta para cá depois, ex.: tag NFC)
    return <Navigate to="/login" state={{ from: `${location.pathname}${location.search}` }} />;
  }

  // Árbitro só acessa a tela de partidas; goleiro, a tela de check-in
  if (userLogado?.perfil === 'Arbitro') {
    return <Navigate to="/arbitro" />;
  }
  if (userLogado?.perfil === 'Goleiro' && !permitirGoleiro) {
    return <Navigate to="/goleiro" />;
  }

  // Se estiver autenticado, permite o acesso à rota
  return children;
}
